import React from 'react';
import PropTypes from 'prop-types';
import { Map} from 'immutable';

import Input from '@Components/Input';


export default function GroupOfMoreInput (props) {
  const {
    id,
    option,
    groupId,
    optionId,
    onChangeInput,
    disableIncludeAndMoreGroup,
  } = props;
  const title = option.get('title');
  const inputValue = option.get('inputValue');

  return (
    <>
      <Input
        className='group-of-more-input'
        disabled={disableIncludeAndMoreGroup}
        animatedPlaceholder
        onChange={(val) => {
          onChangeInput(id, groupId, optionId, val);
        }}
        value={inputValue}
        placeholder={title}
      />
    </>
  );
}

GroupOfMoreInput.propTypes = {
  id: PropTypes.string.isRequired,
  option: PropTypes.instanceOf(Map),
  groupId: PropTypes.string.isRequired,
  optionId: PropTypes.string.isRequired,
  disableIncludeAndMoreGroup: PropTypes.bool.isRequired,
};
